import type { SourceHealth } from '@/types';
import { sourceHealthLabel } from './sourceHealth';

const DISPLAY_NAMES: Record<string, string> = {
  autoscout24: 'AutoScout24',
  kleinanzeigen: 'Kleinanzeigen',
  njuskalo: 'Njuskalo',
  mobile_de: 'Mobile.de',
};

export function sourceHealthDisplayName(sourceName: string): string {
  return DISPLAY_NAMES[sourceName] ?? sourceName.replace(/_/g, ' ');
}

export function sourceHealthPillStatus(health: SourceHealth): string {
  if (health.status === 'OK') return 'OK';
  if (health.status === 'RECOVERING') return 'RECOVERING';
  if (health.status === 'COOLDOWN' || health.status === 'BLOCKED' || health.status === 'FAILING') {
    return sourceHealthLabel(health).split(':')[0].trim();
  }
  return health.status;
}

export function sourceHealthPillClass(health: SourceHealth): string {
  switch (health.status) {
    case 'OK':
      return 'runtime-dot-up';
    case 'RECOVERING':
    case 'DEGRADED':
      return 'runtime-dot-warn';
    case 'COOLDOWN':
      return health.root_error_code === 'ACCESS_DENIED' ? 'runtime-dot-down' : 'runtime-dot-warn';
    case 'BLOCKED':
    case 'FAILING':
      return 'runtime-dot-down';
    default:
      return 'runtime-dot-unknown';
  }
}

export function sortSourceHealthForRuntime(rows: SourceHealth[]): SourceHealth[] {
  const priority = (h: SourceHealth) => {
    if (h.status === 'BLOCKED' || h.status === 'FAILING') return 0;
    if (h.status === 'COOLDOWN') return 1;
    if (h.status === 'RECOVERING' || h.status === 'DEGRADED') return 2;
    return 3;
  };
  return [...rows].sort((a, b) => {
    const pd = priority(a) - priority(b);
    if (pd !== 0) return pd;
    return sourceHealthDisplayName(a.source_name).localeCompare(
      sourceHealthDisplayName(b.source_name)
    );
  });
}
